module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'h:00 a'),
      "unit": 'Hour',
      "unitClass": 'label-success',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'hour',
      "received": _vm.chartsData['hour-stats'].total,
      "growth": _vm.chartsData['hour-stats'].growth,
      "stats": _vm.chartsData['hour-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'hour'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'hour'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'hour'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['hour-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'dddd Do'),
      "unit": 'Day',
      "unitClass": 'label-info',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'day',
      "received": _vm.chartsData['day-stats'].total,
      "growth": _vm.chartsData['day-stats'].growth,
      "stats": _vm.chartsData['day-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'day'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'day'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'day'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['day-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'MMMM'),
      "unit": 'Month',
      "unitClass": 'label-primary',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'month',
      "received": _vm.chartsData['month-stats'].total,
      "growth": _vm.chartsData['month-stats'].growth,
      "stats": _vm.chartsData['month-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'month'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'month'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'month'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['month-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'YYYY'),
      "unit": 'Year',
      "unitClass": 'label-danger',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'year',
      "received": _vm.chartsData['year-stats'].total,
      "growth": _vm.chartsData['year-stats'].growth,
      "stats": _vm.chartsData['year-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'year'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'year'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'year'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['year-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Total vs unique")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['unique-stats']['total-vs-unique'].length)) ? _c('analytics-chart', {
    attrs: {
      "type": "bar",
      "chartStyle": "max-height: 200px;",
      "barPercentage": 0.9,
      "categoryPercentage": 1,
      "scalesEnabled": false,
      "data": _vm.chartsData['unique-stats']['total-vs-unique'].filter(function (s) { return s[0] !== 'x'; })
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['unique-stats']['total-vs-unique'].length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Total by campaign")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.chartsData['campaign-stats']['points'].length > 1) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px;",
      "data": _vm.chartsData['campaign-stats']['points'].map(function (s) { return [s.campaign, s.total]; })
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartsData['campaign-stats']['points'].length <= 1) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Total by channel type")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.processChannelStats.length) ? _c('analytics-chart', {
    attrs: {
      "type": "polar-area",
      "chartStyle": "max-height: 200px;",
      "data": _vm.processChannelStats
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.processChannelStats.length) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'PolarChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Heat map")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean([_vm.chartsData['heat-map-stats'].points].length)) ? _c('analytics-heat-map', {
    attrs: {
      "data": _vm.chartsData['heat-map-stats'].points,
      "range": _vm.chartsData['heat-map-stats'].range
    },
    on: {
      "onChangeDate": function($event) {
        return _vm.$emit('changeDate', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(Object.keys(_vm.chartsData['heat-map-stats'].points).length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsHeatMapLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "450"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Chart")]), _vm._v(" "), _c('div', {
    staticClass: "chart-filters pull-right"
  }, [_c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedFilter === 'timeslot'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'timeslot'
        })
      }
    }
  }, [_vm._v("Timeslots")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedFilter === 'channel'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'channel'
        })
      }
    }
  }, [_vm._v("Channels")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedFilter === 'campaign'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'campaign'
        })
      }
    }
  }, [_vm._v("Campaigns")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.mainChartData.stats.points.length)) ? _c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.mainChartData.stats.points,
      "unit": _vm.units[_vm.units.indexOf(_vm.selectedPeriod) - 1],
      "showLegend": false
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.mainChartData.stats.points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'EngagementGraphLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c17e7ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/EngagementsDashboard.vue
// module id = 3234
// module chunks = 3